import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import MainHeader from './MainHeader';
import NavLinks from './NavLinks';
import SideDrawer from './SideDrawer';
import Backdrop from '../UIElements/Backdrop';
import './MainNavigation.css';

const MainNavigation = (props) => {
	const [ showDrawer, SetShowDrawer ] = useState(false);
	const openDrawerHandler = () => {
		SetShowDrawer(true);
	};
	const closeDrawerHandler = () => {
		SetShowDrawer(false);
	};
	return (
		<React.Fragment>
			{showDrawer && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={showDrawer} onClick={closeDrawerHandler}>
				<nav className="main-navigation__drawer-nav">
					<NavLinks />
				</nav>
			</SideDrawer>)
			<MainHeader>
				<button className="main-navigation__menu-btn" onClick={openDrawerHandler}>
					<span />
					<span />
					<span />
				</button>
				<h1 className="main-navigation__title">
					<Link to="/">Travely</Link>
				</h1>
				<nav className="main-navigation__header-nav">
					<NavLinks />
				</nav>
			</MainHeader>
		</React.Fragment>
	);
};

export default MainNavigation;
